import { render, staticRenderFns } from "./keyBoard.vue?vue&type=template&id=cbc70f12&scoped=true&"
import script from "./keyBoard.vue?vue&type=script&lang=js&"
export * from "./keyBoard.vue?vue&type=script&lang=js&"
import style0 from "./keyBoard.vue?vue&type=style&index=0&id=cbc70f12&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbc70f12",
  null
  
)

export default component.exports